import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'audits',
  inputShow: gql`
    query audits($input: AuditQueryInput) {
      audits(input: $input) {
        id
        auditable_id
        auditable_type
        action
        created_at
        audited_changes
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: false,
  },
};
